(function () {
  const disclaimerLink = document.querySelector(
    ".ts-collection--disclaimer-handle"
  );
  const disclaimerText = document.querySelector(
    ".ts-collection--disclaimer .text-container"
  );
  const svg = document.querySelector(".ts-collection--disclaimer-handle svg");

  disclaimerLink.addEventListener("click", () => {
    disclaimerText.classList.toggle("invisible");
    svg.classList.toggle("rotated");
  });
})();
